import { render, staticRenderFns } from "./noodCseg.vue?vue&type=template&id=67c5fb25&scoped=true"
import script from "./noodCseg.vue?vue&type=script&lang=js"
export * from "./noodCseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5fb25",
  null
  
)

export default component.exports